import { gql } from '@apollo/client'

/**
 * Plain `gql` rather than gql.tada: `graphql-env.d.ts` is generated from a
 * running backend, and these fields only exist on the FD-614 backend branch.
 * Switch to `graphql()` once that is on develop.
 */
export const ISSUE_FIELD_CONFIGS_QUERY = gql`
  query IssueFieldConfigs {
    issueFieldConfigs {
      field
      section
      order
      labelOverride
      visibleOnCreate
      requiredOnCreate
      visibleOnEdit
      requiredOnEdit
      canHide
      canRequire
    }
  }
`

export const SET_ISSUE_FIELD_CONFIGS_MUTATION = gql`
  mutation SetIssueFieldConfigs($configs: [IssueFieldConfigInput!]!) {
    setIssueFieldConfigs(configs: $configs) {
      ok
      issueFieldConfigs {
        field
        section
        order
        labelOverride
        visibleOnCreate
        requiredOnCreate
        visibleOnEdit
        requiredOnEdit
        canHide
        canRequire
      }
    }
  }
`
